import { render } from "./tenantDetails.vue?vue&type=template&id=9397698e&scoped=true"
import script from "./tenantDetails.vue?vue&type=script&lang=js"
export * from "./tenantDetails.vue?vue&type=script&lang=js"

import "./tenantDetails.vue?vue&type=style&index=0&id=9397698e&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9397698e"]])

export default __exports__